"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateJob = exports.runJob = exports.deleteJobById = exports.deleteBatchJobById = exports.checkCronExpressionIsValid = exports.changeStatusJob = exports.addJob = void 0;
var _api = _interopRequireDefault(require("_l/api.request"));
/**
 * 添加定时任务调度表
 * @param job
 * @returns {ClientHttp2Stream | * | AxiosPromise<any> | ClientRequest | void}
 */
var addJob = exports.addJob = function addJob(job) {
  return _api.default.request({
    url: '/monitor/job/save',
    method: 'post',
    data: job
  });
};

/**
 * 运行一次
 * @param jobId
 * @returns {AxiosPromise}
 */
var runJob = exports.runJob = function runJob(jobId) {
  return _api.default.request({
    url: '/monitor/job/run',
    method: 'post',
    params: {
      jobId: jobId
    }
  });
};

/**
 * 修改定时任务调度表
 * @param job
 * @returns {ClientHttp2Stream | * | AxiosPromise<any> | ClientRequest | void}
 */
var updateJob = exports.updateJob = function updateJob(job) {
  return _api.default.request({
    url: '/monitor/job/update',
    method: 'post',
    data: job
  });
};

/**
 * 切换状态
 * @param job
 * @returns {*}
 */
var changeStatusJob = exports.changeStatusJob = function changeStatusJob(job) {
  return _api.default.request({
    url: '/monitor/job/changeStatus',
    method: 'post',
    data: job
  });
};

/**
 * 删除定时任务调度表
 * @param id
 * @returns {ClientHttp2Stream | * | AxiosPromise<any> | ClientRequest | void}
 */
var deleteJobById = exports.deleteJobById = function deleteJobById(id) {
  return _api.default.request({
    url: '/monitor/job/delete',
    method: 'post',
    params: {
      id: id
    }
  });
};

/**
 * 批量删除定时任务调度表
 * @param ids
 * @returns {ClientHttp2Stream | * | AxiosPromise<any> | ClientRequest | void}
 */
var deleteBatchJobById = exports.deleteBatchJobById = function deleteBatchJobById(ids) {
  return _api.default.request({
    url: '/monitor/job/deleteBatch',
    method: 'post',
    data: ids
  });
};

/**
 * 校验cron表达式是否有效
 * @param cronExpression
 * @returns {AxiosPromise}
 */
var checkCronExpressionIsValid = exports.checkCronExpressionIsValid = function checkCronExpressionIsValid(cronExpression) {
  return _api.default.request({
    url: '/monitor/job/checkCronExpressionIsValid',
    method: 'post',
    params: {
      cronExpression: cronExpression
    }
  });
};